/* Tiroir panier Ivelano. Voir snippets/ivelano-panier.liquid.
   Offre Duo Hiver : assets/ivelano-duo.js ; carrousel accessoires :
   assets/ivelano-reco.js (charges avant).
   v20 : bouton « Voir le panier » retire ; carrousel « Completez votre
   tenue » sous les articles ; window.ivCartRefresh expose. */
(function(){
  if(window.__ivCart) return; window.__ivCart = true;

  var D = window.ivDuo || {
    charger: function(){ return Promise.resolve(null); }, pret: function(){ return false; },
    active: function(){ return false; }, bandeau: function(){ return ''; },
    proposer: function(){}, ouvert: function(){ return false; }, cacher: function(){}
  };
  var R = window.ivReco || {
    charger: function(){ return Promise.resolve(null); }, pret: function(){ return true; }, html: function(){ return ''; }
  };

  var tiroir = document.getElementById('iv-cart');
  if(!tiroir) return;
  var corps  = tiroir.querySelector('[data-iv-cart-body]');
  var bas    = tiroir.querySelector('[data-iv-cart-bas]');
  var lignes = tiroir.querySelector('[data-iv-cart-lignes]');
  var titre  = tiroir.querySelector('[data-iv-cart-titre]');
  var ferm   = tiroir.querySelector('.iv-cart__x');
  var rendu  = null;
  var appelant = null;
  var msgCode = null;

  var nf = new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function eur(c){ return nf.format((c || 0) / 100) + '€'; }
  function esc(s){
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function remises(panier){
    var liste = (panier.cart_level_discount_applications || []).map(function(d){
      var app = d.discount_application || d;
      var montant = (d.amount != null) ? d.amount : app.total_allocated_amount;
      return { titre: app.title || '', montant: montant || 0 };
    });
    var parTitre = {};
    (panier.items || []).forEach(function(it){
      (it.line_level_discount_allocations || []).forEach(function(a){
        var t = (a.discount_application && a.discount_application.title) || '';
        parTitre[t] = (parTitre[t] || 0) + (a.amount || 0);
      });
    });
    Object.keys(parTitre).forEach(function(t){ liste.push({ titre: t, montant: parTitre[t] }); });
    return liste.filter(function(r){ return r.montant > 0; });
  }

  function ouvrir(){
    if(tiroir.classList.contains('is-on')) return;
    tiroir.hidden = false;
    tiroir.setAttribute('aria-hidden','false');
    void tiroir.offsetWidth;
    tiroir.classList.add('is-on');
    document.body.style.overflow = 'hidden';
    appelant = document.activeElement;
    if(ferm) ferm.focus();
  }
  function fermer(){
    tiroir.classList.remove('is-on');
    tiroir.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
    window.setTimeout(function(){ if(!tiroir.classList.contains('is-on')) tiroir.hidden = true; }, 560);
    if(appelant && appelant.focus) appelant.focus();
  }
  tiroir.addEventListener('click', function(e){
    if(e.target.closest('[data-iv-cart-close]')) fermer();
  });
  document.addEventListener('keydown', function(e){
    if(e.key !== 'Escape') return;
    if(D.ouvert()){ D.cacher(); return; }
    if(tiroir.classList.contains('is-on')) fermer();
  });

  function lire(){
    return fetch('/cart.js', { headers: { 'Accept':'application/json' } }).then(function(r){ return r.json(); });
  }

  function ligne(it){
    var src = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
    var img = src ? '<img src="' + esc(src) + '" alt="' + esc(it.product_title) + '" width="76" height="100" loading="lazy">' : '';
    var opt = (it.variant_title && it.variant_title !== 'Default Title') ? '<span class="iv-cl__v">' + esc(it.variant_title) + '</span>' : '';
    var prix = eur(it.final_line_price);
    if(it.original_line_price > it.final_line_price) prix = '<s>' + eur(it.original_line_price) + '</s>' + prix;
    return '<div class="iv-cl" data-cle="' + esc(it.key) + '">'
      + '<div class="iv-cl__img">' + img + '</div>'
      + '<div class="iv-cl__in">'
        + '<p class="iv-cl__t"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></p>'
        + opt
        + '<button class="iv-cl__rm" type="button" data-iv-rm>Retirer</button>'
        + '<div class="iv-cl__b">'
          + '<span class="iv-qte">'
            + '<button type="button" data-iv-moins aria-label="Retirer un exemplaire">−</button>'
            + '<span>' + it.quantity + '</span>'
            + '<button type="button" data-iv-plus aria-label="Ajouter un exemplaire">+</button>'
          + '</span>'
          + '<span class="iv-cl__p">' + prix + '</span>'
        + '</div>'
      + '</div>'
    + '</div>';
  }

  function codesActifs(p){
    return ((p && p.discount_codes) || []).filter(function(c){ return c.applicable; }).map(function(c){ return c.code; });
  }
  function majCodes(liste){
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ discount: liste.join(',') })
    }).then(function(r){ return r.json(); });
  }
  function blocCode(panier){
    if(D.active(panier)){
      return '<div class="iv-cart__code is-off"><div class="iv-cart__code-f">'
        + '<input type="text" placeholder="Code de réduction" disabled aria-label="Code de réduction">'
        + '<button type="button" disabled>Appliquer</button></div>'
        + '<p class="iv-cart__code-msg" role="status">Code non cumulable avec l’offre Duo Hiver.</p></div>';
    }
    var codes = codesActifs(panier);
    var h = '<div class="iv-cart__code"><div class="iv-cart__code-f">'
      + '<input type="text" data-iv-code-in placeholder="Code de réduction" autocomplete="off" autocapitalize="characters" spellcheck="false" aria-label="Code de réduction">'
      + '<button type="button" data-iv-code-ok>Appliquer</button></div>';
    if(codes.length){
      h += '<div class="iv-cart__badges">' + codes.map(function(c){
        return '<span class="iv-cart__badge">' + esc(c)
          + '<button type="button" data-iv-code-rm="' + esc(c) + '" aria-label="Retirer le code ' + esc(c) + '">×</button></span>';
      }).join('') + '</div>';
    }
    if(msgCode){
      h += '<p class="iv-cart__code-msg' + (msgCode.err ? ' is-err' : '') + '" role="status">' + esc(msgCode.txt) + '</p>';
      msgCode = null;
    }
    return h + '</div>';
  }
  function appliquerCode(saisie, btn){
    var code = String(saisie || '').trim();
    if(!code){ msgCode = { txt:'Saisissez un code de réduction.', err:true }; dessiner(rendu); return; }
    var deja = codesActifs(rendu).some(function(c){ return c.toLowerCase() === code.toLowerCase(); });
    if(deja){ msgCode = { txt:'Ce code est déjà appliqué.', err:true }; dessiner(rendu); return; }
    if(btn) btn.disabled = true;
    majCodes(codesActifs(rendu).concat([code])).then(function(p){
      var c = (p.discount_codes || []).filter(function(x){ return String(x.code).toLowerCase() === code.toLowerCase(); })[0];
      if(c && c.applicable){ msgCode = { txt:'Code ' + c.code + ' appliqué.', err:false }; return rafraichir(); }
      return majCodes(codesActifs(p)).then(function(){
        msgCode = { txt:'Ce code n’est pas valide ou ne s’applique pas à votre panier.', err:true };
        return rafraichir();
      });
    }).catch(function(){ msgCode = { txt:'Le code n’a pas pu être vérifié. Réessayez.', err:true }; return rafraichir(); });
  }
  function retirerCode(code){
    var reste = codesActifs(rendu).filter(function(c){ return c !== code; });
    majCodes(reste).then(function(){ msgCode = { txt:'Code ' + code + ' retiré.', err:false }; return rafraichir(); }).catch(rafraichir);
  }

  function dessiner(panier){
    if(D.active(panier) && codesActifs(panier).length && !dessiner.purge){
      dessiner.purge = true;
      majCodes([]).then(lire).then(function(p){ dessiner.purge = false; dessiner(p); })
        .catch(function(){ dessiner.purge = false; });
    }
    rendu = panier;
    titre.textContent = panier.item_count > 0 ? 'Votre panier (' + panier.item_count + ')' : 'Votre panier';

    if(panier.item_count === 0){
      corps.innerHTML = '<div class="iv-cart__vide"><p>Votre panier est vide.</p>'
        + '<a class="iv-btn iv-btn--ghost" href="/collections/all"><span>Voir la collection</span></a></div>';
      bas.hidden = true;
      lignes.innerHTML = '';
      return panier;
    }

    /* Donnees pas encore chargees : on les charge puis on redessine. */
    if(!D.pret()) D.charger().then(function(x){ if(x && rendu) dessiner(rendu); });
    if(!R.pret()) R.charger().then(function(x){ if(x && rendu) dessiner(rendu); });

    corps.innerHTML = panier.items.map(ligne).join('') + D.bandeau(panier) + R.html(panier);

    var r = remises(panier);
    var html = blocCode(panier);
    if(r.length){
      html += '<div class="iv-cart__l"><span>Sous-total</span><span>' + eur(panier.original_total_price) + '</span></div>';
      r.forEach(function(x){
        html += '<div class="iv-cart__l iv-cart__l--rem"><span>' + esc(x.titre) + '</span><span>−' + eur(x.montant) + '</span></div>';
      });
    }
    lignes.innerHTML = html
      + '<div class="iv-cart__l iv-cart__l--tot"><span>Total</span><span>' + eur(panier.total_price) + '</span></div>'
      + '<p class="iv-cart__note">Livraison gratuite en France métropolitaine. Taxes incluses.</p>'
      + '<div class="iv-cart__act">'
        + '<button class="iv-btn iv-btn--full" type="button" data-iv-checkout><span>Commander</span></button>'
      + '</div>';
    bas.hidden = false;
    return panier;
  }

  function rafraichir(){ return lire().then(dessiner); }
  window.ivCartRefresh = rafraichir;

  function erreur(msg){
    var e = document.createElement('p');
    e.className = 'iv-cart__err';
    e.setAttribute('role','alert');
    e.textContent = msg;
    corps.appendChild(e);
    corps.scrollTop = corps.scrollHeight;
  }

  function changer(cle, qte){
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ id: cle, quantity: qte })
    }).then(rafraichir);
  }
  corps.addEventListener('click', function(e){
    var l = e.target.closest('.iv-cl');
    if(!l) return;
    var cle = l.getAttribute('data-cle');
    var it = rendu && rendu.items.filter(function(x){ return x.key === cle; })[0];
    if(!it) return;
    if(e.target.closest('[data-iv-plus]'))  changer(cle, it.quantity + 1);
    if(e.target.closest('[data-iv-moins]')) changer(cle, it.quantity - 1);
    if(e.target.closest('[data-iv-rm]'))    changer(cle, 0);
  });

  tiroir.addEventListener('click', function(e){
    if(e.target.closest('[data-iv-checkout]')) window.location.href = '/checkout';
    var ok = e.target.closest('[data-iv-code-ok]');
    if(ok){ var champ = tiroir.querySelector('[data-iv-code-in]'); appliquerCode(champ && champ.value, ok); }
    var rm = e.target.closest('[data-iv-code-rm]');
    if(rm) retirerCode(rm.getAttribute('data-iv-code-rm'));
  });
  tiroir.addEventListener('keydown', function(e){
    if(e.key === 'Enter' && e.target.matches && e.target.matches('[data-iv-code-in]')){
      e.preventDefault();
      appliquerCode(e.target.value, tiroir.querySelector('[data-iv-code-ok]'));
    }
  });

  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var lab = btn && btn.querySelector('span:not(.iv-btn__ar):not(.iv-btn__p)');
    var avant = lab ? lab.textContent : null;
    if(btn) btn.disabled = true;
    if(lab) lab.textContent = 'Ajout…';
    fetch('/cart/add.js', { method:'POST', body:new FormData(form), headers:{ 'Accept':'application/json' } })
      .then(function(r){ return r.json().then(function(j){ return { ok:r.ok, j:j }; }); })
      .then(function(res){
        return rafraichir().then(function(){
          ouvrir();
          if(!res.ok) erreur(res.j.description || res.j.message || 'Cet article n’a pas pu être ajouté.');
          else D.proposer(res.j, rendu);
        });
      })
      .catch(function(){ form.submit(); })
      .then(function(){
        if(btn) btn.disabled = false;
        if(lab && avant !== null) lab.textContent = avant;
      });
  }, true);

  document.addEventListener('click', function(e){
    var a = e.target.closest('a[href$="/cart"], a[href$="/cart/"]');
    if(!a) return;
    if(a.closest('.iv-cart')) return;
    if(e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    rafraichir().then(ouvrir);
  }, true);
})();